import { useRouter } from 'next/router';
import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';

export default function Topbar() {
  const { user, logout } = useAuth();
  const router = useRouter();
  const [menuOpen, setMenuOpen] = useState(false);

  async function handleLogout() {
    await logout();
    router.replace('/login');
  }

  const initial = user?.name?.trim()?.[0]?.toUpperCase() ?? '?';

  return (
    <header className="fixed inset-x-0 top-0 z-10 flex h-16 items-center justify-between border-b border-gray-200 bg-white px-6 shadow-base">
      <span className="font-heading text-lg font-bold text-gray-800">
        Marketplace <span className="text-accent">ERP</span>
      </span>

      <div className="relative">
        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          className="flex items-center gap-2 focus:outline-none"
        >
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-accent text-sm font-semibold text-white">
            {initial}
          </div>
        </button>

        {menuOpen && (
          <div className="absolute right-0 mt-2 w-56 rounded bg-white py-1 shadow-base">
            <div className="border-b border-gray-100 px-4 py-3">
              <p className="text-sm font-semibold text-gray-800">{user?.name}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
              <p className="mt-1 text-xs font-medium uppercase tracking-wide text-accent">
                {user?.roleName ?? 'No role'}
              </p>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              className="block w-full px-4 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
